<canvas
    baseChart
    [data]="bubbleChartData"
    [options]="bubbleChartOptions"
    [legend]="true"
    [type]="bubbleChartType">
</canvas>